export default __webpack_public_path__ + "static/media/Nakuum.99dba3d2.jpg";